export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            有建议、反馈或合作意向？欢迎通过以下方式联系我们
          </p>
        </div>

        <div className="max-w-[600px] mx-auto">
          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
              <div className="text-center p-4">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center mx-auto bg-primary-100 text-primary-600 rounded-xl mb-3">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">电子邮箱</div>
                <div className="text-sm font-medium text-foreground-900">contact@51nav.com</div>
              </div>
              <div className="text-center p-4">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center mx-auto bg-accent-100 text-accent-600 rounded-xl mb-3">
                  <i className="ri-message-3-line text-lg"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">在线反馈</div>
                <div className="text-sm font-medium text-foreground-900">7×24小时响应</div>
              </div>
              <div className="text-center p-4">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center mx-auto bg-secondary-100 text-secondary-600 rounded-xl mb-3">
                  <i className="ri-service-line text-lg"></i>
                </div>
                <div className="text-xs text-foreground-500 mb-1">商务合作</div>
                <div className="text-sm font-medium text-foreground-900">partner@51nav.com</div>
              </div>
            </div>

            <div className="text-center">
              <p className="text-sm text-foreground-500 mb-4">
                站点收录申请、内容投稿、广告合作等需求，欢迎随时联系我们
              </p>
              <a
                href="#hero"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 text-background-50 font-semibold px-6 py-3 rounded-xl hover:bg-primary-600 transition-colors duration-200 cursor-pointer text-sm"
              >
                回到首页
                <i className="ri-arrow-up-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}